/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBriefcaseArrowRight = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m22.414 18-3.707 3.707-1.414-1.414L18.586 19H15v-2h3.586l-1.293-1.293 1.414-1.414z" />
        <path d="M17 7h5v6h-2V9H4v10h9v2H2V7h5V3h10zM9 7h6V5H9z" />
      </g>
    </g>
  </Icon>
);
export { SvgBriefcaseArrowRight as BriefcaseArrowRight };
